import { FormattedMessage } from 'react-intl';
import { generatePath } from 'react-router';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  LICENSED_PARTNERS_SPORT,
  LICENSED_PARTNERS_SPORT_TAB,
} from '@sorare/core/src/constants/__generated__/routes';

const FiltersWrapper = styled(Horizontal)`
  flex: 1;
  align-self: flex-start;
`;

export const FootballTabs = () => {
  return (
    <FiltersWrapper>
      <TabBar variant="secondary" compact>
        <Tab
          to={generatePath(LICENSED_PARTNERS_SPORT_TAB, {
            sport: 'football',
            tab: 'clubs',
          })}
          matches={[
            generatePath(LICENSED_PARTNERS_SPORT, { sport: 'football' }),
          ]}
        >
          <FormattedMessage defaultMessage="Clubs" />
        </Tab>
        <Tab
          to={generatePath(LICENSED_PARTNERS_SPORT_TAB, {
            sport: 'football',
            tab: 'leagues',
          })}
        >
          <FormattedMessage defaultMessage="Leagues" />
        </Tab>
      </TabBar>
    </FiltersWrapper>
  );
};
